export default __webpack_public_path__ + "static/media/image5.d28ef931.jpg";